module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAAKCAMAAACOlf6TAAAAAXNSR0IArs4c6QAAADxQTFRFAAAAAAD/AED/ADv/ADb/ADr/ADn/ADr/ADr/ADv/ADr/ADv/ADv/ADz/ADv/ADv/ADv/ADz/ADv/ADz/rJ5A8QAAABN0Uk5TAAIEDRMjNkJccJCjvcnc7PL7/cvueLcAAABGSURBVAgdXcGHDcAgAAOwsMqe+f/XIoRQqY3AnwAReYkCkIkfSWJSmUdWWHThVjQ2U7lUg+NpnNqDD9vJbnFxYzj8eI/tBUusBq8CUtTWAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./static/img/indexStyle3/jt.png
// module id = E2cL
// module chunks = 1